export default "__VITE_ASSET__CRq9XXOO__"